import { RobotOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import axios from '../api';
import './HomeStats.css';

const STAT_CARDS = [
  { key: 'student_count', icon: '🎓', iconColor: '#5a7d1a', label: '在校学生', bg: 'linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%)', format: (v) => v },
  { key: 'graduate_count', icon: '🎓', iconColor: '#3b6ed6', label: '毕业学生', bg: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)', format: (v) => v },
  { key: 'token_usage', icon: '🔑', iconColor: '#00bcd4', label: 'Token 用量', bg: 'linear-gradient(135deg, #e0f2f1 0%, #f3e5f5 100%)', format: (v) => Number(v).toLocaleString() },
  { key: 'agent_count', icon: 'robot', iconColor: '#e91e63', label: '智能体', bg: 'linear-gradient(135deg, #fce4ec 0%, #fff3e0 100%)', format: (v) => v || 0 },
  { key: 'knowledge_count', icon: '📚', iconColor: '#9c27b0', label: '知识库', bg: 'linear-gradient(135deg, #e8eaf6 0%, #f3e5f5 100%)', format: (v) => v },
  { key: 'document_count', icon: '📝', iconColor: '#5a7d1a', label: '文档总数', bg: 'linear-gradient(135deg, #e8f5e9 0%, #f1f8e9 100%)', format: (v) => Number(v).toLocaleString() },
  { key: 'cloud_space_count', icon: '☁️', iconColor: '#3b6ed6', label: '云空间', bg: 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)', format: (v) => v },
];

const DEFAULT_STATS = {
  student_count: 0,
  graduate_count: 0,
  token_usage: 0,
  knowledge_count: 0,
  cloud_space_count: 0,
  document_count: 0,
  agent_count: 0,
};

const HomeStats = () => {
  const [stats, setStats] = useState(DEFAULT_STATS);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await axios.get('/api/dashboard-stats/');
        setStats(response.data);
      } catch (error) {
        console.log('使用默认统计数据');
      } finally {
        setLoading(false);
      }
    };

    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="home-stats-loading">
        <div style={{ fontSize: 16, color: '#666' }}>加载统计数据中...</div>
      </div>
    );
  }

  return (
    <div className="home-stats">
      <div className="home-stats-grid">
        {STAT_CARDS.map(({ key, icon, iconColor, label, bg, format }) => (
          <div key={key} className="home-stats-card" style={{ background: bg }}>
            {icon === 'robot' ? (
              <RobotOutlined style={{ fontSize: 24, color: iconColor, marginBottom: 6 }} />
            ) : (
              <span style={{ fontSize: 24, color: iconColor, marginBottom: 6 }}>{icon}</span>
            )}
            <div style={{ fontSize: 20, fontWeight: 700, color: '#333' }}>{format(stats[key])}</div>
            <div style={{ color: '#666', marginTop: 2, fontSize: 12 }}>{label}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeStats;
